module.exports = __webpack_public_path__ + "static/media/sharpRight.bc2d1cc5.svg";